import '@/assets/styles/main.css';
import { bootstrap } from '@/app/bootstrap';

bootstrap().mount('#app');
